<template>
  <div class="main">
    <ColorPattern :uniq_key="uniq_key"></ColorPattern>
    <div class="header">
      <div class="buttons">
        <router-link :to="cart && cart.length ? cart[cart.length-1].path : '/'" class="back">
          <vk-icon icon="triangle-left" ratio="2"></vk-icon>
        </router-link>
        <span>カート</span>
      </div>
    </div>
    <div class="content">
      <div v-if="cart.length > 0">
        <transition-group name="list" tag="div" class="transition">
          <CartItem v-bind="cartItem" v-for="(cartItem, key) in cart"
                    @clickDelete="modalDelete(cartItem)" @clickChange="clickChange(key)"
                    :key="cartItem.code" class="cart-item" :uniq_key="uniq_key"/>
        </transition-group>
      </div>
      <div v-else style="text-align: center; padding-top: 3rem; min-height:10rem;">
        <p>カートは空です</p>
        <p>
          <button class="btn btn-secondary" @click="$router.push('/h/popular/')">TOPページへ</button>
        </p>
      </div>
    </div>
    <div class="footer">
      <div class="band total_prices">
        <span class="total_number">合計 {{ totalNumber }}枚</span>
        <span class="total_price">{{ totalPrice | money }}</span>
        <router-link to="./payment/confirm/yahoo" class="btn btn-danger">注文手続き</router-link>
      </div>
    </div>
    <vk-modal class="cart_modal" :show.sync="modalShow" center>
      <vk-modal-title>削除しますか？</vk-modal-title>
      <div slot="footer">
        <vk-button class="btn btn-secondary btn-block" @click="clickDelete">はい</vk-button>
        <vk-button class="btn btn-secondary btn-block" @click="modalShow=false">いいえ</vk-button>
      </div>
    </vk-modal>
  </div>
</template>

<script>
  import CartItem from './cart/Item';
  import ColorPattern from './ColorPattern';

  export default {
    name: 'Cart',
    components: {
      CartItem, ColorPattern,
    },
    data () {
      return {
        modalShow: false,
        selectedItem: null,
        uniq_key: new Date().getTime().toString(16)  + Math.floor(1000 * Math.random()).toString(16),
      }
    },
    computed: {
      cart() {
        return this.$store.state.cart;
      },
      totalNumber() {
        let number = 0;
        this.cart.forEach(cart => {
          number += cart.number;
        });
        return number;
      },
      totalPrice() {
        let price = 0;
        this.cart.forEach(cart => {
          price += cart.price * cart.number;
        });
        return price;
      },
    },
    methods: {
      modalDelete (item) {
        this.modalShow = true;
        this.selectedItem = item;
      },
      clickDelete() {
        this.modalShow = false;
        this.$store.commit('removeCart', this.selectedItem);
      },
      clickChange(key) {
        const cartItem = this.cart[key];
        this.$router.push({'path': '/' + cartItem.item_id
          , 'query': {'cart': key}
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .header {
    position: sticky;
    position: -webkit-sticky;
    top: 48px;
    z-index:999;
  }
  .buttons {
    background-color: rgb(128, 127, 128);
    color: #fff;
    font-weight: bold;
    overflow: hidden;

    .back {
      color: rgb(240, 240, 240) !important;
      float: left;
      display: block;
    }

    span {
      float: right;
      display: block;
      padding-right: 10px;
      line-height: 40px;
      height: 40px;
    }

    &:after {
      clear: both;
    }
  }

  .footer {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
  }

  .band {
    width: 100%;
    color: #fff;
    padding: 0.5rem;
    display: flex;
    justify-content: space-between;
  }

  .cart-item {
    border-top: 1px solid #f6f6f6;
    border-bottom: 2px solid #e4e0f0;
  }

  .total_prices {
    background-color: #595959;
    .total_number, .total_price {
      line-height: 38px;
    }
  }

  /* enter、 leave アニメーションで異なる間隔やタイミング関数を利用することができます */
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }

  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active, .list-leave-active {
    transition: all .4s;
  }
  .list-enter, .list-leave-to /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateX(-30px);
  }
</style>
